import { makeStyles } from "@material-ui/core/styles";
export const HeaderCommonCss = makeStyles((theme) => ({
  navBoxMenu: {
    "& > .menuItem": {
      fontSize: "1.4rem",
      fontWeight: "600",
      padding: "0 13px 32px !important",
      color: " #1A1A31 !important",
      textTransform: "uppercase",
      transition: "background 0.2s, color 0.2s",
      cursor: "pointer",
      textDecoration: "none",
    },
    "& > .menuItem:hover": {
      color: "#FF4717 !important",
    }
    
  },
  
  menuItem: {
    "& .innerMenuItemBox": {
      display: "none",
    },
    "&:hover .innerMenuItemBox": {
      display: "block",
    },
  },
  innerMenuItemBox: {
    top: "114px",
    background: "#1A1A31",
    height: "240px",
    zIndex: 101,
    padding: "10px",
    color: "#fff",
    "& a": {
      color: "#fff !important",
      fontSize: "18px",
      transition: "background 0.2s, color 0.2s",
      cursor: "pointer",
      textDecoration: "none",
      padding: " 0px",
      fontWeight: 500,
      textTransform: "capitalize",
    },
    "& a:hover": {
      color: "#FF4717 !important",
    },
  },
}));
